export default __webpack_public_path__ + "static/media/panel.6f27a077.svg";